<template>
  <v-btn @click="copy()"  outlined small color="indigo" class="download-btn white--text">            
      <v-icon dark small>mdi-pencil</v-icon>
      Copy URL
  </v-btn>
</template>

<script>
export default {
  name: 'CopyBanner',
  props: ['banner'],
  methods: {
    copy () {
      let url = `https://www.piwi247.com/signup?referral_code=${this.banner.referral_code}`
      navigator.clipboard.writeText(url).then(() => {
        this.$emit('copied')
      })
    }
  }
}
</script>
<style scoped>
</style>